@reference "~/styles.css";

@layer components {
	/* F O R M   F I E L D */

	.formField {
		&:where(.vertical) {
			@apply flex flex-col items-start;
		}

		&:where(.horizontal) {
			@apply flex flex-row items-center;
		}
	}

	/* F O R M   L A B E L */

	.formLabel {
		@apply block text-15 leading-5.5 font-medium text-grey-900 cursor-default last:mb-0;

		:where(.formField.vertical) & {
			@apply mb-3;
		}

		/* reset margin for nested form-label */
		:where(.formField.vertical) & & {
			@apply mb-0;
		}

		:where(.formField.horizontal) & {
			@apply mb-0;
		}

		/* stretch the form-label if it has a nested form-label */
		:where(.formField.vertical) &:has(&) {
			@apply w-full flex items-center justify-between;
		}

		:where(.formField.horizontal) &:has(&) {
			@apply w-full flex items-center;
		}
	}

	/* F O R M   M E S S A G E */

	.formMessage {
		&:where(:not(.unstyled)) {
			@apply m-0 text-sm text-grey-800;

			&:where(.error) {
				@apply text-red-500;
			}
		}

		* + & {
			@apply mt-2;
		}
	}

	/* F O R M   F I E L D   R E S E T */

	.formFieldReset {
		@apply aria-hidden:opacity-0 aria-hidden:pointer-events-none;

		&:not(.unstyled) {
			@apply text-xs font-normal outline-hidden inline cursor-pointer text-primary-600 motion-safe:transition-[color,opacity];
			@apply hover:text-inherit;
			@apply focus-visible:ring-2 ring-primary-500/30 ring-offset-2 rounded-xs;
			@apply aria-disabled:cursor-not-allowed! aria-disabled:text-grey-500!;
			@apply aria-busy:cursor-wait! aria-busy:text-grey-500!;
		}
	}
}
